<template>
    <div class="d-flex flex-column w-100">
		<nav-bar/>
		<banner titulo="Gerenciar Arquivos Primeseg" subTitulo="Gerencie arquivos que os clientes enviaram"/>
        <div class="d-flex flex-md-row flex-wrap flex-column w-75 mx-auto mt-2 p-md-5 p-3 gap-md borda">
            <form class="d-flex flex-column gap-md w-100">
                <div class="d-flex flex-md-row flex-column w-100 gap-md">
                    <div class="d-flex flex-column w-100">
                        <label>Pessoa Física:</label>
						<auto-complete-pessoa-fisica :disabled="tipoPessoaUsuario == `pessoaJuridica`" ref="filtroPessoaFisica" @pessoaSelecionada="setaCpfPessoaFisicaPesquisada($event)"/>
					</div>
                </div>
                <div class="d-flex flex-md-row flex-column w-100 gap-md">
                    <div class="d-flex flex-column w-100">
                        <label>Pessoa Jurídica:</label>
						<auto-complete-pessoa-juridica :disabled="tipoPessoaUsuario == 'pessoaFisica'" ref="filtroPessoaJuridica" @pessoaSelecionada="setaCpfPessoaJuridicaPesquisada($event)"/>
                    </div>
                </div>
                <div class="d-flex gap-sm">
                    <div class="d-flex gap-sm">
                        <label>Pessoa Jurídica</label>
                        <input @input="limparFormularioFiltro" @change="filtrarUsuarios" type="radio" value="pessoaJuridica" v-model="tipoPessoaUsuario">
                    </div>
                    <div class="d-flex gap-sm">
                        <label>Pessoa Física</label>
                        <input @input="limparFormularioFiltro" @change="filtrarUsuarios" type="radio" value="pessoaFisica" v-model="tipoPessoaUsuario">
                    </div>
                    </div>
                    <div class="d-flex flex-md-row flex-column gap-sm mx-md-0 mx-auto" style="justify-content: space-between;">
                        <div class="d-flex gap-sm">
                            <b-button variant="primary" @click="filtrarUsuarios">Filtrar</b-button>
                            <b-button variant="secondary" @click="limparFormularioFiltro">
	                                Limpar
	                        </b-button>
	                    </div>
    	            </div>
    	            </form>
                <b-table striped hover :items="usuarios" :fields="fields" show-empty :responsive="true" :busy="carregando">
                    <template #empty >
                        <div class="d-flex">
                        <span class="mx-auto">
                        Nenhum Registro Encontrado
                    </span>
                    </div>
                </template>
                <template #table-busy>
                    <div class="text-center text-primary my-2">
                        <b-spinner class="align-middle"></b-spinner>
                    </div>
                </template>
                <template #cell(index)="data">
                    {{ data.index + 1 }}
                </template>
                <template #cell(cpfCnpj)="data">
                    {{ data.item.cpf == null ? $options.filters.addMascara(data.item.cnpj, "cnpj") : $options.filters.addMascara(data.item.cpf, "cpf") }}
                </template>
				<template #cell(acao)="data">
                    <modal-gerenciar-arquivos-primeseg :usuario="data.item" ref="modalGerenciarArquivosPrimeseg"/>
                    <b-button variant="secondary" @click="abrirModalGerenciarArquivosPrimeseg(data.item.id)">Selecione</b-button>
				</template>
            </b-table>
            <b-pagination class="mx-auto" v-model="paginaAtualTabelaUsuarios" :total-rows="numeroDeLinhasTabelaUsuarios" :per-page="usuariosPorPagina"
                @input="consultarUsuarios"></b-pagination>
        </div>
    </div>
</template>

<script>

import Pessoa from "../../model/Pessoa.js";
import UsuarioService from "../../service/UsuarioService.js";
import Banner from "../../components/shared/Banner.vue";
import AutoCompletePessoaFisica from "../../components/pessoa/AutoCompletePessoaFisica.vue";
import AutoCompletePessoaJuridica from "../../components/pessoa/AutoCompletePessoaJuridica.vue";
import NavBar from "../../components/shared/NavBar.vue";
import ModalGerenciarArquivosPrimeseg from "../../components/GerenciarArquivosPrimeseg/ModalGerenciarArquivosPrimeseg.vue";


export default {
	components: { Banner, AutoCompletePessoaFisica, AutoCompletePessoaJuridica, NavBar, ModalGerenciarArquivosPrimeseg },
	name: "GerenciarArquivosPrimeseg",
 		data() {
		return {
			usuario: new Pessoa(),
			filtrosUsuario: new Pessoa(),
			tipoPessoaUsuario: "pessoaJuridica",
			carregando: false,
			usuarios: [],
			fields: [],
			numeroDeLinhasTabelaUsuarios: 0,
			paginaAtualTabelaUsuarios: 1,
			usuariosPorPagina: 15,
			cpfPessoaPesquisada: "",
			cnpjPessoaPesquisada: "",
		};
	},
	created() {
		this.filtrarUsuarios();
		this.setaColunasDasTabelas();
	},
	computed: {
		selecionaMascaraTelefone() {
			return this.usuario.telefone.length <= 14 ? "(##) ####-####" : "(##) #####-####";
		},

	},
	methods: {
		setaCpfPessoaFisicaPesquisada(cpf) {
			this.cpfPessoaPesquisada = cpf;
		},
		setaCpfPessoaJuridicaPesquisada(cnpj) {
			this.cnpjPessoaPesquisada = cnpj;
		},
		abrirModalGerenciarArquivosPrimeseg(idUsuario) {
			this.$bvModal.show("modal-gerenciar-arquivos-primeseg-" + idUsuario);
		},
		setaColunasDasTabelas() {
			if (this.tipoPessoaUsuario == "pessoaJuridica") {
			 	this.fields = [
					{ label: "#", key: "index" },
			 		{ label: "Razão Social", key: "razaoSocial" },
					{ label: "Email", key: "email" },
					{ label: "CNPJ", key: "cpfCnpj" },
					{ label: "", key: "acao" },
				];
			 } else {
				this.fields = [
					{ label: "#", key: "index" },
			 		{ label: "Nome Completo", key: "nome" },
					{ label: "Email", key: "email" },
			 		{ label: "CPF", key: "cpfCnpj" },
					{ label: "", key: "acao" },
				];
			}
		},
		limparFormularioFiltro() {
			this.filtrosUsuario = new Pessoa();
			this.$refs.filtroPessoaFisica.limpar();
			this.$refs.filtroPessoaJuridica.limpar();
			this.cpfPessoaPesquisada = "";
			this.cnpjPessoaPesquisada = "";
		},
		filtrarUsuarios() {
			this.paginaAtualTabelaUsuarios = 1;
			this.consultarUsuarios();
		},
		consultarUsuarios() {
			this.carregando = true;


			UsuarioService.consultarUsuarios(
				this.tipoPessoaUsuario,
				"",
				this.cpfPessoaPesquisada,
				this.cnpjPessoaPesquisada,
				this.paginaAtualTabelaUsuarios - 1,
				this.usuariosPorPagina)
				.then((res) => {
					this.usuarios = res.data[1];
					this.setaColunasDasTabelas();
				}).catch((err) => {
					console.log(err);
				}).finally(() => {
					this.carregando = false;
				});
		},
		mensagem(msg, titulo, variant) {
			this.$bvToast.toast(msg, {
				title: titulo,
				autoHideDelay: 6000,
				appendToast: true,
				variant,
				toaster: "b-toaster-bottom-right",
			});
		},
	},
};
</script>

  <!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.borda {
    box-shadow: 0px 0px 2px 0px grey;
    min-height: 80vh;
    justify-content: center;
}

</style>




// WEBPACK FOOTER //
// src/views/arquivosPrimeseg/GerenciarArquivosPrimeseg.vue